import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { AppService } from '@services/app.services';
import { ConfigurationService } from '@services/configuration.service';

import { ModalComponent } from '@shared/modal/modal.component';
import { ModalTypes } from '@shared/modal/modal.interface';

import { MainCartService } from '../../services/main-cart.service';
import { PrismeLoggerService } from '../../services/prisme-logger.service';

@Component({
    selector: 'checkout-fai-error-modal',
    standalone: true,
    imports: [CommonModule, ModalComponent],
    templateUrl: './fai-error-modal.component.html',
    styleUrls: [],
})
export class FaiErrorModalComponent extends ModalComponent {
    type: ModalTypes = 'error';
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_erreur_eligibilite',
        categorieClic: 'Modale_erreur',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Redirect_Eligibilite',
        categorieClic: 'Modale_erreur_eligibilite',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_erreur_eligibilite',
    };

    title: string = `Une Bbox est déjà associée à cette adresse`;
    protected appService: AppService = inject(AppService);
    protected configService: ConfigurationService = inject(ConfigurationService);
    protected cartService: MainCartService = inject(MainCartService);
    protected prismeLogger: PrismeLoggerService = inject(PrismeLoggerService);

    public ngOnInit(): void {
        try {
            this.prismeLogger.sendLogToPrisme('Affichage_modale_erreur_doublon_commande', null);
        } catch (error) {
            console.log(error);
        }

        this.modalRef.crossClicked.subscribe({
            next: () => {
                this.resetAndRedirect('https://www.bouyguestelecom.fr');
            },
            error: () => {
                this.appService.navigateTo('https://www.bouyguestelecom.fr');
            },
        });
    }

    public redirect(): void {
        this.resetAndRedirect();
    }

    public redirectToCallBack(): void {
        this.resetAndRedirect(
            'https://www.bouyguestelecom.fr/mon-compte/rappel-client?serviceID=wcb_FAI_Retractation_Bbox_Web',
        );
    }

    private resetAndRedirect(redirectUrl: string = this.configService.getData().global.wall.account): void {
        try {
            this.cartService.reset();
            this.appService.navigateTo(redirectUrl);
        } catch (error) {
            this.appService.navigateTo(redirectUrl);
        }
    }
}
